import Link from 'next/link';

import { productUrl } from '../../../utils/productUrl';
import { Image } from '../../Image';
import { ProductPrice } from '../../ProductPrice/ProductPrice';

interface Props {
  product: Product;
}

export const StoryDetailsProduct: React.FC<Props> = ({ product }) => {
  return (
    <Link
      className="group mt-2 flex items-center"
      href={productUrl(product.full_slug!, product.releaseType)}
      locale={false}
    >
      <div className="mr-2 h-12 w-12">
        <Image alt={product.title} hoverEffect src={product.image} width={48} />
      </div>
      <div className="flex min-w-0 flex-col overflow-ellipsis">
        <div className="truncate transition duration-300 group-hover:text-neutral-4">
          {product.title}
        </div>
        <ProductPrice
          className="text-neutral-4"
          price={Number(product.price)}
        />
      </div>
    </Link>
  );
};

export default StoryDetailsProduct;
